const BezierFormula = (time) => (time * time * (3 - 2 * time));

const ExpandedBezierFormula = (time, start, end, duration) => {
  const reducedTime = time / duration; //  For BezierFormula time needs to be between 0 and 1
  return (BezierFormula(reducedTime) * (end - start) + start);
};

export { BezierFormula, ExpandedBezierFormula };
